import * as React from 'react'

import { CollapsableCard, MediumIcon } from '@factorialco/deprecated-design-system'

import { track, trackingEvents } from 'modules/core/lib/Tracking'

import { usePricingContext } from 'modules/onboarding/components/Pricing/PricingContext'
import type Plan from 'modules/onboarding/lib/pricing/plans/Plan'

import Card from './_Card'
import Content from './_Content'

type CommonProps = {
  icon: MediumIcon
  plan: Plan
  isCore?: boolean
}

const ModuleCard = ({ icon, plan, isCore = false }: CommonProps) => {
  const [open, setOpen] = React.useState(isCore)
  const { setVariantForPlan, togglePlanSelect } = usePricingContext()

  const cleanPlanName = (planName: string) =>
    planName.replace(/Business|Enterprise|business|enterprise/, '').trim()

  const trackAmplitude = () => {
    track(
      plan.isSelected ? trackingEvents.billing.addedAModule : trackingEvents.billing.removedAModule,
      {
        module_name: cleanPlanName(plan.internalTitle),
        plan: plan.activeVariantType,
      }
    )
  }

  const togglePlan = () => {
    togglePlanSelect(plan)
    trackAmplitude()
  }

  return (
    <CollapsableCard
      open={open}
      Card={
        <Card
          plan={plan}
          toggleSelectedPlan={togglePlan}
          disabled={isCore}
          icon={icon}
          isOpen={open}
          toggleOpen={() => {
            setOpen(!open)
          }}
        />
      }
      Content={
        <Content
          toggleSelectedPlan={(variant) => {
            if (!plan.isSelected) {
              togglePlanSelect(plan)
            }
            setVariantForPlan(variant, plan)
            trackAmplitude()
          }}
          plan={plan}
          isCore={isCore}
        />
      }
    />
  )
}

export default ModuleCard
